import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_PHONE_SERVICE_BASE,
  async load() {
    await authentication.isAuthenticated();
    return axios
      .get(this.baseUrl + "/GetSettings", {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async save(settings) {
    await authentication.isAuthenticated();
    return axios
      .post(this.baseUrl + "/SaveSettings", settings, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadEvents(dates) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/GetUserEvents`, dates, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async createEventFile(events) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/CreateUserEventFile`, events, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async emailEventFile(data) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/EmailUserEvents`, data, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
